import { retry } from "@reduxjs/toolkit/query";
import React, { useEffect, useState } from "react";
import InputAHSF from "../../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  AddSU_NT_MRI_PublishedSientific,
  GetOneSU_NT_MRI_PublishedSientificResearch,
  UpdateSU_NT_MRI_PublishedSientific,
} from "../../../../Redux/Reducers/Submitter/PublishedScientificRes";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import $ from "jquery";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";

const AddEditePublished = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const [validateLink, setvalidateLink] = useState(false);
  const [validateReference, setvalidateReference] = useState(false);
const urlRegex = /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+([\/?#][^\s]*)?$/i;


  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      publishedSientificResearch:
        state.PublishedScientificRes.publishedSientificResearch,
      loadingpublishedSientificResearch:
        state.PublishedScientificRes.loadingpublishedSientificResearch,
    };
  });
  const [list, setList] = useState({
    reference: null,
    link: null,
    applicationInformationId:
      localStorage.getItem("ApplicationInformationId") ||
      decryptToken(AppGuid.AppGuid),
  });
  const [show, setShow] = useState(false);
  const addPublished = async () => {
    console.log(list.link, "list.link", list.reference);

    if (
      list.link &&
      urlRegex.test(list.link) &&
      list.reference != "" &&
      list.reference != null
    ) {
      const add = await dispatch(
        AddSU_NT_MRI_PublishedSientific({
          reference: list.reference,
          link: list.link,
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            decryptToken(AppGuid.AppGuid),
        })
      );

      if (add.payload) {
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم اضافة المعلومات بنجاح", // "Information updated successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });

        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    } else {
      if (!list.link || !urlRegex.test(list.link)) {
        setvalidateLink(true);
      }
      if (list.reference == "" || list.reference == null) {
        setvalidateReference(true);
      }
    }
  };

  const updatePublished = async () => {
    if (
      list.link &&
      urlRegex.test(list.link) &&
      list.reference != "" &&
      list.reference != null
    ) {
      const update = await dispatch(
        UpdateSU_NT_MRI_PublishedSientific({
          publishedSientificResearchId: list.publishedSientificResearchId,
          reference: list.reference,
          link: list.link,
          applicationInformationId: list.applicationInformationId,
        })
      );

      if (update.payload) {
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم تعديل المعلومات بنجاح", // "Information updated successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });

        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    } else {
      if (!list.link || !urlRegex.test(list.link)) {
        setvalidateLink(true);
      }
      if (list.reference == "" || list.reference == null) {
        setvalidateReference(true);
      }
    }
  };

  const getData = async () => {
    if (props.canEdit) {
      const data = await dispatch(
        GetOneSU_NT_MRI_PublishedSientificResearch(
          props.publishedSientificResearchId
        )
      );

      if (data.payload) {
        setList({ ...data.payload });
        setShow(true);
      }
    } else {
      setShow(true);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return !state.loadingpublishedSientificResearch && show ? (
    <>
      <div className="AddEdite">
        <InputAHSF
          fieldsName="Reference"
          show={true}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              reference: e.target.value,
            });
          }}
          defaultValue={list?.reference}
          showValidationMessage={validateReference}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
         {state.jsonData ? (
          <p className="linkMassage">{state.jsonData?.LinkMassage}</p>
        ) : (
          ""
        )}
        <InputAHSF
          fieldsName="link"
          // type={"url"}
          show={true}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              link: e.target.value,
            });
            setvalidateLink(false); // reset on change
          }}
          onBlur={(e) => {
            if (!urlRegex.test(e.target.value)) {
              setvalidateLink(true);
            }
          }}
          defaultValue={list?.link}
          showValidationMessage={validateLink}
          validationMessage={list?.link?"يرجى تعبئة رابط صحيح":"يرجى تعبئة هذا الحقل"}
        />
        {!props.shouldDisableFields ? (
          <div className="containersButton">
            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  props.canEdit == "edit" ? updatePublished() : addPublished();
                }}
                disabled={false}
                title={props.canEdit == "edit" ? "تعديل" : "اضافة"}
                text={props.canEdit == "edit" ? "تعديل" : "اضافة"}
                show={true}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  ) : (
    ""
  );
};

export default AddEditePublished;
